export default "__VITE_PUBLIC_ASSET__bfb24df3__"